import React from 'react';
import PropTypes from 'prop-types';
import SearchSortSelect from './search_sort_select';

export default function SortBy(props) {
  const { sortOrder, setSortOrder, forAffiliate, hideSort } = props;

  if (hideSort === true) {
    return null;
  }

  return (
    <div className="snapgadget_refine">
      <SearchSortSelect
        defaultSortText="Sort By"
        sortOrder={sortOrder}
        onChange={(sortOrder) => {setSortOrder(sortOrder);}}
        forAffiliate={forAffiliate}
        defaultDisabled />
    </div>
  );
}

SortBy.propTypes = {
  sortOrder: PropTypes.string,
  setSortOrder: PropTypes.func,
  forAffiliate: PropTypes.bool,
  hideSort: PropTypes.bool,
};
